import React from "react";
import AppRoutes from "../routes";
import HomePage from "../pages/ncc/home_page";
const NccTemplate = () => {
  return (
    <div>
      <React.Fragment>
        <AppRoutes homePage={HomePage} />
      </React.Fragment>
    </div>
  );
};

export default NccTemplate;
